import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import LocalStorage from "../../Constants/LocalStorage";
import {
  AppStorageKeys,
  DefaultBasePathMenu,
  DefaultMenu,
  NavMenuItems,
} from "../../Constants/Constants";

export const PrivateRoute = ({
  component: Component,
  componentProps,
  ...rest
}) => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const isLoggedIn = currentUser && currentUser.access_token;

  /* not logged in, redirect to login page */
  if (!isLoggedIn) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
    );
  }

  /*
   * for basepath '/': check for what is the default base menu
   * if it is tips page and tips hide are checked, redirect to default menu
   */
  const hideMessageTip = LocalStorage.get(AppStorageKeys.tipMessage);
  const hideTechTip = LocalStorage.get(AppStorageKeys.tipTech);
  if (
    rest.path === "/" &&
    DefaultBasePathMenu === NavMenuItems.tips.key &&
    hideMessageTip &&
    hideTechTip
  ) {
    return <Redirect to={{ pathname: DefaultMenu }} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} {...componentProps} />}
    />
  );
};
